import { c as _c } from "react/compiler-runtime";
import { RatingWithProfileInfoAndLevel } from "@/entities/IProfile";
import { ProfileRatersTableType } from "@/enums";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import ProfileRatersTableItem from "./ProfileRatersTableItem";
export default function ProfileRatersTableBody(t0) {
  const $ = _c(7);
  const {
    ratings,
    type
  } = t0;
  let t1;
  if ($[0] !== ratings || $[1] !== type) {
    let t2;
    if ($[3] !== type) {
      t2 = rating => <ProfileRatersTableItem key={getRandomObjectId()} rating={rating} type={type} />;
      $[3] = type;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = ratings.map(t2);
    $[0] = ratings;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <tbody className="tw-divide-y tw-divide-iron-800 tw-divide-solid tw-divide-x-0">{t1}</tbody>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}